import { computed } from 'vue';
import { MinimalOrganisationDto } from '@studyportals/campaign-management-api-interface';
import { LoadingStatuses } from '@/models/loading.interface';
import store from '@/store';

export default class ImportCampaignConfigurationCode {
	public isLoading = computed((): boolean => {
		const loadingStatus = store.getters.loadingStatusPrimaryData();
		return loadingStatus === LoadingStatuses.ACTIVE;
	});

	public isImportModalActive = computed((): boolean => {
		return store.getters.isImportCampaignConfigurationModalActive();
	});

	public hasLinkedOrganisations = computed((): boolean => {
		return this.linkedOrganisations.value.length > 0;
	});

	private linkedOrganisations = computed((): MinimalOrganisationDto[] => {
		return store.getters.linkedOrganisations();
	});

	public openImportModal(): void {
		store.mutations.setImportCampaignConfigurationModalActive(true);
	}
}
